// version-check.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
declare const window: any;

@Injectable({
  providedIn: 'root',
})
export class VersionCheckService {
  private currentVersion: string = '';

  constructor(private http: HttpClient) {}

  public initVersionCheck(url: string, intervalTime: number = 60000): void {
    // 1 minute
    let mismatchCount = 0;
    const mismatchThreshold = 3; // 3 minutes = 3 intervals

    this.http.get<{ version: string }>(url).subscribe((versionObj) => {
      this.currentVersion = versionObj.version;
    });

    interval(intervalTime)
      .pipe(switchMap(() => this.http.get<{ version: string }>(url)))
      .subscribe((versionObj) => {
        if (this.currentVersion && versionObj.version !== this.currentVersion) {
          mismatchCount++;
          if (mismatchCount >= mismatchThreshold) {
            window.location.reload(true); // Hard reload
          }
        } else {
          // Versions match again — reset the mismatch counter
          mismatchCount = 0;
        }
      });
  }
}
